/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement } from 'react';
import { AnimatedSlide } from '../animated-slide';
import { Page191 } from './pages/page-19-1';
import { Page201 } from './pages/page-20-1';

@observer
export class Slide22 extends AnimatedSlide {
  // Animation players
  players = {};

  // Run the first animation
  componentDidMount() {
    const { page, page2, arrow, label } = this.players;

    this.steps = [
      // Step 1
      () => {
        this.animateProgress(1000);
      },
      () => {},
    ];

    this.animations = [
      //
      // Step 1
      //
      [
        {
          targets: page,
          easing: 'easeOutQuad',
          opacity: 0,
          duration: 500,
          delay: 200,
        },
        {
          targets: page2,
          easing: 'easeOutQuad',
          opacity: 1,
          duration: 500,
          delay: 200,
        },
      ],
    ];

    // Play the first animation
    this.play();
  }

  render() {
    const { children, className = '' } = this.props;

    return (
      <div className={`slide-22 ${className}`}>
        {children}
        <div className="content">
          {/* page1 */}
          <div
            className="player page"
            data-active="1"
            ref={node => (this.players.page = node)}
          >
            <Page191 />
          </div>

          {/* page 2 */}
          <div
            className="player page2"
            data-active="1"
            ref={node => (this.players.page2 = node)}
          >
            <Page201 />
          </div>
        </div>
      </div>
    );
  }
}
